// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dcb8abec","455":"89b87165","977":"0f49e8f2"}[chunkId] + ".chunk.js";
};